<template>
	<div>
		{{ tradable.qty.mt }},
		{{
			tradable.qty.partial_ok
				? __("Partial quantity possible")
				: __("Partial quantity not desired")
		}}
	</div>
</template>

<script>
export default {
	props: {
		tradable: {
			type: Object,
			required: true,
		},
	},
};
</script>
